import React from "react";
import { Configurator } from "./pages/Configurator";
export function App() {
  return <Configurator data-id="element-0" data-mp="35ckb29dc16k1" />;
}